import {inject} from '@angular/core';
import {ResolveFn, Router} from '@angular/router';
import {GlobalModelService} from './GlobalModel.service';
import {AppService} from './app.service';
import {UserOpeService} from './ope/userOpe.service';
import {AuthStateService} from './auth/auth-state.service';
import {PostLoginCB} from '../ope/user/PostLoginCB';

export const postLoginResolver: ResolveFn<void> = async () => {
  const gmService = inject(GlobalModelService);
  const appService = inject(AppService);
  const userService = inject(UserOpeService);
  const authState = inject(AuthStateService);
  const router = inject(Router);

  if (gmService.user?.menuItems) {
    return;
  }

  if (!authState.isLoggedIn()) {
    router.navigate(['']);
    return;
  }

  try {
    const cb = new PostLoginCB();
    cb.i.channel = appService.APP_CHANNEL;
    await userService.postLogin(cb);
    appService.storeParamsIntoGlobalModel(cb);
  } catch {
    authState.clear();
    router.navigate(['']);
  }
};
